module.exports = __webpack_public_path__ + "051d282886704d304f0a684322a10771.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_stacked_bar_1hour_show.png
// module id = 898
// module chunks = 7